import React, { FC } from 'react'
import {useIntl} from 'react-intl';
import BaseKpi from './BaseKpi'
import {TrxKpiModel} from '../../core/_models';

interface Props {
  data: TrxKpiModel;
  isLoading: boolean;
}

export const PaymentKpi: FC<Props> = ({ data, isLoading }) => {
  const intl = useIntl();

  const format = (value: number) => intl.formatNumber(value)
  const moneyFormat = (value: number) =>
    intl.formatNumber(value, { style: 'currency', currency: 'EUR' });
  const percFormat = (value: number) => {
    const _ = intl.formatNumber(value, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })

    return `${_}%`
  }

  const rows = [{
    label: 'Paid',
    curr: data.paid.curr,
    prev: data.paid.prev,
    icon: 'euro',
    format: moneyFormat
  }, {
    label: 'Payouts',
    curr: data.payout.curr,
    prev: data.payout.prev,
    icon: 'chart-pie-simple',
    format: moneyFormat
  }, {
    label: 'Transactions',
    curr: data.nb.curr,
    prev: data.nb.prev,
    icon: 'two-credit-cart',
    format
  }, {
    label: 'Earnings',
    curr: data.earnings.curr,
    prev: data.earnings.prev,
    icon: 'chart-pie-3',
    format: moneyFormat
  }, {
    label: 'Margin',
    curr: data.earnings.curr / (data.payout.curr || 1) * 100,
    prev: data.earnings.prev / (data.payout.prev || 1) * 100,
    icon: 'percentage',
    format: percFormat
  }]

  return (
    <BaseKpi
      color="success"
      title="Payment summary"
      label="Payouts"
      value={moneyFormat(data.payout.curr)}
      isLoading={isLoading}
      rows={rows}
    />
  )
}
